import { vimsSFTPActionNames } from './types';
import VimsSFTPFileReport from '../../services/vims-sftp-file-report';
import { AppThunkDispatch, AppState } from '..';
import { GetVimsSFTPReport } from '../../services/types';
import { enqueueSnackbarAction } from '../snackbar/actions';
// import { downloadFromUrl } from '../../globals/utils';

export const getVimsSFTPReportAction =
  (input: GetVimsSFTPReport) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        login: { envVariables, client },
      } = getState();
      try {
        const vimsSFTPFileReport = new VimsSFTPFileReport(
          client,
          envVariables.vimsSFTPReportV1,
          envVariables.storageV1BaseUrl,
        );
        dispatch({ type: vimsSFTPActionNames.SET_IS_LOADING, payload: true });
        dispatch(
          enqueueSnackbarAction({
            message: 'Vims SFTP Report CSV export initiated',
            options: { key: (Date.now() + Math.random()).toString(), variant: 'success' },
          }),
        );
        await vimsSFTPFileReport.exportVimsSFTPReportFile(input, dispatch).then((url: any) => url);
        // downloadFromUrl(response);
      } catch (error) {
        dispatch({ type: vimsSFTPActionNames.SET_IS_LOADING, payload: false });
        dispatch(
          enqueueSnackbarAction({
            message: 'Vims SFTP Report CSV export failed',
            options: { key: (Date.now() + Math.random()).toString(), variant: 'error' },
          }),
        );
      }
    };
